<template>
  <div id="live-detail">

    <div v-if="showMask" class="live-mask">
      <div class="enter-btn" @click="enterLiveRoom">进入直播间</div>
    </div>

    <tcplayer ref="tcplayer" v-if="loaded" :source="m3u8"
      :cover="liveInfo.mediumCover + `?datatime=${new Date().getTime()}`" :autoplay="false"></tcplayer>
    <div v-if="liveInfo.status != 'RESERVATION' && !liveInfo.showPlayNumber && isShowPlayNumber"
      style="position: fixed;top: 40px;left: 20px;z-index: 22;font-size:12px;background-color:rgba(0, 0, 0, 0.4);color:#FFF;border-radius:10px;padding:4px 10px">
      <img src="@/assets/img/eye.png" alt="logo" style="width:18px;height:10px;" />
      <span style="margin-left:10px;margin-top:-3px">{{ liveInfo.playNumber | filterData }}</span>
    </div>
    <div ref="showLeftStationLogo" v-if="liveInfo.showLeftStationLogo"
      style="position: fixed;top: 0px;left: 0px;z-index: 99999999;">
      <img src="@/assets/station_logoLeft.png" alt="logo" style="width:100%" />
    </div>
    <div ref="showRightStationLogo" v-if="liveInfo.showRightStationLogo"
      style="position: fixed;top: 0px;right: 0px;z-index: 99999999;">
      <img src="@/assets/station_logoRight.png" alt="logo" style="width:100%" />
    </div>

    <div style="position:relative">
      <div class="download" @click="download">下载APP</div>
      <el-tabs v-model="activeName" @tab-click="handleClick" style="flex-grow:1;" :stretch="true">
        <el-tab-pane label="已结束" name="over" v-if="liveInfo.status == 'LOOK_BACK'">
          <div
            :style="{ height: `${windowHeight - Math.floor(windowWidth * 9 / 16 + contentMargin)}px`, overflowY: 'scroll' }">
            <div style="display:flex;align-items:center;flex-direction:column">
              <div style="font-size:28px;margin:10px 0px 15px">直播已结束</div>
              <div>{{ liveInfo.playNumber | filterData }} 观看</div>
              <div @click="download" style="width:220px;height:60px;border-radius:10px;opacity:0.6;margin:20px 0px;
                background:rgba(255, 204, 153, 1);text-align:center;line-height:60px;color:#FFF">分享回看</div>
            </div>
            <div class="contenTip" v-html="liveInfo.description" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="预约" name="start" v-if="liveInfo.status == 'RESERVATION'">
          <div
            :style="{ height: `${windowHeight - Math.floor(windowWidth * 9 / 16 + contentMargin)}px`, overflowY: 'scroll' }">
            <div style="display:flex;align-items:center;flex-direction:column">
              <div style="text-align:center;font-size:14px;margin-top:20px">
                <count-down :start-time="beginTime" :end-time="endTime" @end_callback="endCallBack" tip-text="开播还有"
                  day-txt="天" hour-txt="小时" minutes-txt="分钟" seconds-txt="秒" />
              </div>
              <div @click="download"
                style="width:230px;height:50px;color:#FFF;display:flex;align-items:center;flex-direction:column;
              border-radius:10px;opacity:0.6;margin:20px 0px;background:#4882cd;text-align:center;justify-content:center">
                <div style="height:20px;line-height:20px">立即预约</div>
                <div style="height:20px;line-height:20px">{{ liveInfo.playNumber | filterData }}人想看</div>
              </div>
              <div @click="goToApp" style="width:230px;height:50px;border-radius:10px;opacity:0.6;margin:0px 0px 20px;
              background:rgba(255, 204, 153, 1);text-align:center;line-height:50px;color:#FFF">分享给好友</div>
              <div class="contenTip" v-html="liveInfo.description" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="聊天互动" name="first">
          <div
            :style="{ height: `${windowHeight - Math.floor(windowWidth * 9 / 16 + contentMargin)}px`, overflowY: 'scroll', background: '#f5f5f5' }">
            <m-list ref="srcollList" :on-refresh="fetchNewData" :on-infinite="fetchNewData"
              style="margin-bottom:3.5rem">
              <div v-for="(item, key) in commentsList" :key="key" style="margin:15px 0px">
                <div style="display:flex;align-items:center" v-if="item.category == 'comment'">
                  <div style="margin:0px 10px">
                    <el-avatar size="large" :src="item.avatar"></el-avatar>
                  </div>
                  <div>
                    <div style="margin-left:5px">
                      <span :class="'name' + item.level">{{ item.userName }}</span>
                      <span :class="'level' + item.level">LV {{ item.level }}</span>
                    </div>
                    <div
                      style="background: rgb(255, 255, 255);padding: 5px 10px 10px;margin-top: 5px;margin-right: 10px;box-shadow: 3px 3px 5px #cfcfcf;border-radius: 10px;">
                      <span v-for="(seg, index) in item.segments" :key="item.id + index" class="text">
                        <span v-if="seg.type == 'text'" :class="'content' + item.level">{{ seg.content }}</span>
                        <img v-if="seg.type == 'img'" :src="require('@/assets/emoji/' + seg.content + '.png')"
                          style="width:20px;height:20px" />
                      </span>
                    </div>
                  </div>
                </div>
                <p v-if="item.category == 'present'">
                  <span :class="'level' + item.level">LV {{ item.level }}</span>
                  <span :class="'name' + item.level">{{ item.userName }}:</span>

                  <span :class="'content' + item.level">送出了{{ item.number }}个</span>

                  <img :src="item.imgUrl" style="width:40px;height:40px" />
                </p>
              </div>
            </m-list>
            <!-- <m-list @toBottom="fetchNewData()" :loading="loading"></m-list> -->
          </div>
        </el-tab-pane>
        <el-tab-pane label="热力榜" name="second">
          <div
            :style="{ height: `${windowHeight - Math.floor(windowWidth * 9 / 16 + contentMargin)}px`, overflowY: 'scroll' }">
            <div v-if="hotRankData && hotRankData.total" style="padding-top: 20px;">
              <div class="hotRank">当前热力：{{ hotRankData.total | filterData }}</div>
            </div>
            <div v-for="(item, key) in hotRankData.hotRank.slice(0, 20)" :key="key"
              style="padding:20px 10px 0px;display:flex;justify-content: space-between;align-items: center;">
              <div style="display:flex;align-items: center;">
                <span v-if="key > 2" style="margin-right:20px;width:25px;text-align:center">{{ key + 1 }}</span>
                <img v-if="key == 0" src="@/assets/img/content/live/rank_desc_O.png" alt="logo"
                  style="width:25px;margin-right:20px" />
                <img v-if="key == 1" src="@/assets/img/content/live/rank_desc_T.png" alt="logo"
                  style="width:25px;margin-right:20px" />
                <img v-if="key == 2" src="@/assets/img/content/live/rank_desc_Th.png" alt="logo"
                  style="width:25px;margin-right:20px" />
                <el-avatar style="margin-right:10px" :size="50" :src="item.avatar"></el-avatar>
                <span style=" white-space:nowrap;overflow: hidden;text-overflow: ellipsis;width:200px">{{ item.username
                }}</span>
              </div>
              <div style="display:flex;align-items: center;justify-content: space-between;">
                <img src="@/assets/img/content/live/icon_comment_hot_small.png" alt="logo" style="width:15px;" />
                <div style="width:25px;text-align:right">{{ item.heat }}</div>
              </div>
            </div>
            <div v-if="hotRankData.hotRank.length >= 20" style="text-align: center;padding: 10px 0px;color: #ccc;">
              最多展示前20名用户
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="直播介绍" name="third" v-if="liveInfo.status == 'LIVE'">
          <div class="contenTip"
            :style="{ height: `${windowHeight - Math.floor(windowWidth * 9 / 16 + contentMargin)}px`, overflowY: 'scroll' }"
            v-html="liveInfo.description" />
        </el-tab-pane>
        <el-tab-pane label="往期回看" name="fourth" v-if="liveInfo.status != 'RESERVATION'">
          <div
            :style="{ height: `${windowHeight - Math.floor(windowWidth * 9 / 16 + contentMargin)}px`, overflowY: 'scroll' }">
            <div @click="changeDetail(item)" v-for="(item, key) in liveInfo.lookBacks" :key="key"
              style="width:48%;display:inline-block;margin:0px 1%;position:relative">
              <img :src="getImageURL(item.cover)" style="width:100%" />
              <span
                style="position: absolute;top: 7px;left: 10px;background: rgba(0,0,0,0.2);color: #FFF;padding: 2px 8px;border-radius: 20px;font-size: 11px;">回看</span>
              <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:0.8rem">{{ item.title }}
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="其他直播" name="otherLive">
          <div
            :style="{ height: `${windowHeight - Math.floor(windowWidth * 9 / 16 + contentMargin)}px`, overflowY: 'scroll' }">
            <div @click="changeOtherDetail(item)" v-for="(item, key) in contentInfoList" :key="key"
              style="width:48%;display:inline-block;margin:0px 1%;position:relative">
              <img :src="getImageURL(item.cover)" style="width:100%" />
              <span
                style="position: absolute;top: 7px;left: 10px;background: rgba(0,0,0,0.2);color: #FFF;padding: 2px 8px;border-radius: 20px;font-size: 11px;">回看</span>
              <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:0.8rem">{{ item.title }}
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="downloadDom" v-if="isShowBanner" :style="{ bottom: activeName == 'first' ? '3.5rem' : '0px' }">
      <div style="display:flex">
        <img src="@/assets/img/news/APP ICON.png" alt="logo" style="width:30px;height:30px;margin:0px 5px" />
        <div>
          <div>下载中国旅游TV手机APP</div>
          <div style="font-size:11px">APP内打开，使用更流畅！功能更强大！</div>
        </div>
      </div>
      <div style="display:flex;align-items: center;margin-right:7px">
        <div class="downloadBtn" @click="download">下载</div>
        <i class="el-icon-error" style="font-size:24px" @click="hiddenBanner"></i>
      </div>
    </div>
    <div class="sendLiveComment" v-if="activeName == 'first'">
      <el-input v-model="commentsParams.content" :disabled="!liveInfo.commentAble"
        :placeholder="`${!liveInfo.commentAble ? '评论已关闭' : '请输入内容'}`"></el-input>
      <div style="display:flex;align-items:center">
        <img src="@/assets/img/content/live/icon_chat_send.png" @click="sendLiveComment" alt="logo"
          style="width:25px;height:25px;margin:0px 10px" />
        <img @click="goToApp" src="@/assets/img/content/live/icon_chat_share.png" alt="logo"
          style="width:25px;height:25px;margin:0px 10px" />
      </div>
    </div>
  </div>
</template>

<script>
import * as request from "@/utils/request";
import { getImageURL } from "@/utils/zgly-utils.js";
import turnBack from "@/components/turnBack";
import tcplayer from "@/components/tcplayer";
import { convertRichComment } from "@/utils/rich-comment.js";
import CountDown from "@/components/CountDown.vue";
import MList from "@/components/list/MList";


export default {
  head() {
    return {
      title: `${this.liveInfo.title ? this.liveInfo.title : "视频"}-`,
      meta: [
        {
          property: 'og:title', content: this.liveInfo.title
        },
        {
          property: 'og:description', content: this.liveInfo.title
        },
        {
          property: 'og:type', content: 'website',
        },
        {
          property: 'og:image', content: this.liveInfo.smallCover
        },
        {
          property: 'og:site_name', content: '旅游TV'
        },
        {
          property: 'og:url', content: 'http://www.my100000.com:8101/live/player/' + this.liveInfo.id
        },
        {
          itemprop: 'name', content: this.liveInfo.title
        },
        {
          itemprop: 'image', content: this.liveInfo.smallCover
        },
        {
          itemprop: 'description', content: this.liveInfo.title
        },
        {
          hid: "description",
          name: "description",
          content: `${this.liveInfo.description
            ? this.liveInfo.description.replace(new RegExp("<.+?>", "g"), "")
            : "中国旅游影视传媒有限公司(中国旅游TV，英文简称CTTV)是在中国旅游局监督指导下，信息产业部、商务部、文化部大 力支持下成立的“互联网+旅游”专业综合平台。中国旅游TV始终坚持开拓多 渠道集群发展产业链与多环节增值的完整生态运作体系，立足于移动互联网， 秉持大盘运作的运营理念，借助资深创意策划以及媒体集团联盟优势，打造集 在线视频、网络直播、线上旅游、城市宣传、生活服务、信息集散、全景VR等 功 能于一体的新型旅游综合门户平台。"
            }`,
        },
        {
          name: 'screen-orientation',
          content: 'portrait'
        }
      ]
    }
  },
  components: {
    turnBack,
    CountDown,
    tcplayer,
    MList,
  },
  data() {
    return {
      windowHeight: 0, //实时屏幕高度
      windowWidth: 0,
      contentMargin: 80,
      liveInfo: {
        previews: [],
        lookBacks: [],
        mediumCover: "",
      },
      loaded: false,
      showMask: true,
      isShowBanner: true,
      commentsList: [],
      contentInfoList: [],
      id: "",
      type: "",
      currentTag: {},
      activeName: "first",
      m3u8: "",
      countTime: 0,
      commentsParams: {
        content: "",
        objectId: 0,
        offset: 0,
        toUserId: 0,
        type: ``,
      },
      hotRankData: {
        total: 0,
        hotRank: []
      },
      currentCommentId: null,
      endTime: 0,
      loading: false,
      websocket: null,
      updatePlayerNumberTimer: null,
      isShowPlayNumber: true,
      showPlayNumberTimer: null,
      MinWidth: 0,
      MaxWidth: 0,
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.cleanupResources();
    this.loaded = false;
    this.id = to.params.id;
    this.type = to.query.type;
    this.$nextTick(() => {
      this.initPage();
    });
    next();
  },
  mounted() {
    this.windowWidth = document.documentElement.clientWidth
    this.windowHeight = document.documentElement.clientHeight;
    this.MinWidth = document.documentElement.clientWidth
    this.MaxWidth = document.documentElement.clientHeight + 40
    this.id = this.$route.params.id;
    this.type = this.$route.query.type;
    this.initPage();
    window.onorientationchange = (e) => {
      if (window.orientation == 0 || window.orientation == 180) {
        this.windowWidth = this.MinWidth
      }
      else if (window.orientation == 90 || window.orientation == -90) {
        this.windowWidth = this.MaxWidth
      }
    }
    // 添加触摸事件监听，实现左右滑动切换随机ID
    // this.addSwipeEvent();
  },
  created() { },
  destroyed() {
    this.cleanupResources();
  },
  filters: {
    filterData(val) {
      return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
    },
  },
  computed: {
    beginTime() {
      return new Date(this.liveInfo.countdown.replace(/-/g, "/")).getTime();
    },
  },
  methods: {
    initPage() {
      if (this.type) {
        this.commentsParams.type = `TO_${this.type}`;
      } else {
        this.commentsParams.type = `TO_LIVE`;
      }
      this.commentsParams.objectId = this.id;
      this.commentsList = [];
      this.currentCommentId = null;
      this.hotRankData = { total: 0, hotRank: [] };
      this.contentInfoList = [];
      this.fetchData().then(() => {
        this.loaded = true;
      }).catch(() => {
        this.loaded = true;
      });
      this.firstSelCommentById();
      this.getContentInfo(10);
      this.getResourceLivesHeatRanks();
      try {
        this.websocket = new WebSocket(
          `ws://www.my100000.com:7000/live?subscribeId=${this.id}&equipmentType=h5`
        );
        this.websocket.onmessage = this.onmessage;
        this.websocket.onopen = this.onopen;
      } catch (e) { }
      this.isShowPlayNumber = true;
      this.updatePlayerNumberTimer = setInterval(() => {
        request.getResourceLivesDetail(this.id).then((res) => {
          this.liveInfo.playNumber = res.data.playNumber;
        }).catch(() => {});
      }, 10000);
      this.showPlayNumberTimer = setTimeout(() => {
        this.isShowPlayNumber = false;
      }, 50 * 1000);
      this.$nextTick(() => {
        if (this.liveInfo.status === 'LOOK_BACK') {
          try {
            if (typeof InitPxVideo !== 'undefined') {
              new InitPxVideo({
                videoId: "video_player",
                captionsOnDefault: true,
                seekInterval: 20,
                videoTitle: "PayPal Austin promo",
                debug: true,
              });
            }
          } catch (e) { }
        }
      });
    },
    cleanupResources() {
      if (this.updatePlayerNumberTimer) {
        clearInterval(this.updatePlayerNumberTimer);
        this.updatePlayerNumberTimer = null;
      }
      if (this.showPlayNumberTimer) {
        clearTimeout(this.showPlayNumberTimer);
        this.showPlayNumberTimer = null;
      }
      if (this.websocket) {
        try {
          this.websocket.close();
        } catch (e) { }
        this.websocket = null;
      }
    },
    async fetchData() {
      let liveInfo = {};
      let m3u8 = "";
      let countTime = "";
      let endTime = "";
      let activeName = "";
      await request.getResourceLivesDetail(this.id).then((res) => {
        liveInfo = res.data;
      });
      switch (liveInfo.status) {
        case "RESERVATION":
          countTime = new Date(liveInfo.countdown.replace(/-/g, "/")).getTime();
          endTime = new Date(liveInfo.countdown.replace(/-/g, "/")).getTime();
          activeName = "start";
          if (liveInfo.previews.length > 0) {
            let arr = liveInfo.previews.filter((_) => _.autoplay);
            if (arr.length > 0) {
              m3u8 = arr[0].url;
            } else {
              m3u8 = liveInfo.previews[0].url;
            }
          } else {
            m3u8 = "";
          }
          break;
        case "LIVE":
          m3u8 = liveInfo.m3u8;
          activeName = "first";
          break;
        case "LOOK_BACK":
          activeName = "over";
          if (liveInfo.lookBacks.length > 0) {
            let arr = liveInfo.lookBacks.filter((_) => _.autoplay);
            if (arr.length > 0) {
              m3u8 = arr[0].url;
            } else {
              m3u8 = liveInfo.lookBacks[0].url;
            }
          }
          break;
      }
      this.liveInfo = liveInfo;
      this.m3u8 = m3u8;
      this.countTime = countTime;
      this.endTime = endTime;
      this.activeName = activeName;
    },
    // 添加滑动事件监听
    addSwipeEvent() {
      let startX = 0;
      let endX = 0;
      const container = document.getElementById('live-detail');

      container.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      container.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].clientX;
        this.handleSwipe(startX, endX);
      });
    },
    // 处理滑动事件
    handleSwipe(startX, endX) {
      const threshold = 50; // 滑动阈值
      if (Math.abs(startX - endX) > threshold) {
        // 生成1000以内的随机数
        const randomId = Math.floor(Math.random() * 1000);
        // 导航到新的URL
        this.$router.push({ path: `/live/player/${randomId}` });
      }
    },
    getResourceLivesHeatRanks() {
      request.getResourceLivesHeatRanks({
        id: this.id
      }).then((res) => {
        if (res.code == 0) {

          this.hotRankData = {
            total: res.data.totalHeat,
            hotRank: res.data.ranks ? res.data.ranks : []
          }
        }
      })
    },
    getContentInfo(val) {
      request.getResourceLivesRecently({ size: val }).then((res) => {
        this.contentInfoList = res.data[0].lives;
      });
    },
    fetchNewData(done) {
      this.selCommentById(done);
    },
    getImageURL(cover) {
      return getImageURL(cover);
    },
    goToApp() {
      this.$notify({
        title: "分享",
        message: "请点击右上角，选择复制链接或直接分享",
      });
      return;
    },
    selCommentById(done) {
      request
        .getCommentsById({
          commentType: this.commentsParams.type,
          objectId: this.id,
          size: 15,
          startCommentId: this.currentCommentId,
        })
        .then((res) => {
          let arr = [];
          res.data.map((element) => {
            arr.unshift(convertRichComment(element));
          });
          this.commentsList = [...arr, ...this.commentsList];
          if (this.commentsList.length > 0) {
            this.currentCommentId = this.commentsList[0].id;
          }
          done();
        });
    },
    firstSelCommentById() {
      request
        .getCommentsById({
          commentType: this.commentsParams.type,
          objectId: this.id,
          size: 15,
          startCommentId: this.currentCommentId,
        })
        .then((res) => {
          let arr = [];
          res.data.map((element) => {
            arr.unshift(convertRichComment(element));
          });
          this.commentsList = [...arr, ...this.commentsList];
          if (this.commentsList.length > 0) {
            this.currentCommentId = this.commentsList[0].id;
          }
          this.$nextTick(() => {
            this.$refs.srcollList.srcollToBottom();
          });
        });
    },
    // 滚到到底部
    commentScrollToEnd() {
      const eles = document.getElementById("scrollDom"); // 只计算获取一次ele
      eles.scrollTop = eles.scrollHeight;
    },
    endCallBack() {
      request.getResourceLivesDetail(this.id).then((res) => {
        this.liveInfo = res.data;
        this.activeName = "first";
        this.$nextTick(() => {
          if (this.$refs.tcplayer) {
            this.$refs.tcplayer.src(this.liveInfo.m3u8);
            this.$refs.tcplayer.play();
          }
        });
      });
    },
    setCountTImer() { },
    changeDetail(item) {
      this.$nextTick(() => {
          if (this.$refs.tcplayer) {
            this.$refs.tcplayer.src(item.url);
            this.$refs.tcplayer.play();
          }
        });
    },
    changeOtherDetail(item) {
      this.$router.push({ path: `/live/player/${item.id}` });
    },
    sendLiveComment() {
      if (!this.commentsParams.content) {
        this.$message('请输入评论内容');
        return;
      }
      if (this.commentsParams.content.length > 100) {
        this.$message('评论内容的字数不能超过100');
        return;
      }
      request.createComments(this.commentsParams).then((res) => {
        this.commentsParams.content = "";
        this.currentCommentId = null;
        this.commentsList = [];
        this.firstSelCommentById();
      });
    },
    download() {
      this.$router.push({ path: `/download` });
    },
    handleClick(tab, event) { },
    hiddenBanner() {
      this.isShowBanner = false;
      this.contentMargin = 40
    },
    onopen() {
      // 订阅 workType-workId
      this.websocket.send("1-" + this.id);
    },
    onmessage(event) {
      var res = JSON.parse(event.data);
      if (res.wsNotificationType === "COMMENT") {
        console.log(res, 'onmessage')
        let data = res.data
        this.commentsList.push(convertRichComment(data))
        this.$nextTick(() => {
          this.$refs.srcollList.srcollToBottom();
        });
      }
    },
    handleShowPlayNumber() {
      if (!this.isShowPlayNumber) {
        this.isShowPlayNumber = true
        this.showPlayNumberTimer = setTimeout(() => {
          this.isShowPlayNumber = false
        }, 5 * 1000)
      }
    },
    // 进入直播间，隐藏毛玻璃遮罩层并开始播放
    enterLiveRoom() {
      this.showMask = false;
      this.$nextTick(() => {
        if (this.$refs.tcplayer) {
          this.$refs.tcplayer.play();
        }
      });
    }
  },
};
</script>

<style lang="less" scope>
#live-detail {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;

  .live-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);

    .enter-btn {
      padding: 12px 40px;
      background: #4882cd;
      color: #fff;
      font-size: 18px;
      border-radius: 25px;
      text-align: center;
      cursor: pointer;
    }
  }

  .el-tabs__header {
    margin: 0px;
    margin-right: 80px;
  }

  .el-tabs__item {
    padding: 0px 10px;

    .el-tabs__nav-wrap::after {
      height: 0px;
    }
  }

  .el-tabs__nav-wrap::after {
    height: 0px;
  }

  .liveTag {
    display: flex;
    margin: 0.5rem;

    div {
      margin-right: 1rem;
    }
  }

  .level0 {
    background: #5bcd48;
    padding: 0px 5px;
    border-radius: 3px;
    font-size: 12px;
    color: #fff;
  }

  .level1 {
    background: #4882cd;
    padding: 0px 5px;
    border-radius: 3px;
    font-size: 12px;
    color: #fff;
  }

  .level2 {
    background: #4882cd;
    padding: 0px 5px;
    border-radius: 3px;
    font-size: 12px;
    color: #fff;
  }

  .level3 {
    background: #fd9559;
    padding: 0px 5px;
    border-radius: 3px;
    font-size: 12px;
    color: #fff;
  }

  .hotRank {
    background: rgba(250, 114, 152, 1);
    width: 240px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    color: #FFF;
    text-align: center;
    border-radius: 10px;
    margin: auto;
  }

  .download {
    border: 0;
    width: 80px;
    height: 2.4rem;
    line-height: 2.4rem;
    color: white;
    font-weight: bold;
    background-color: #4882cd;
    text-align: center;
    position: absolute;
    right: 0px;
    top: 0px;
  }

  .liveCommentList {
    .liveCommentListDiv {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2rem 1rem;
      border-bottom: 1px solid #eee;
    }
  }

  .contenTip {
    padding: 0px 10px;
  }

  .contenTip img {
    width: 100% !important;
  }

  .contenTip p {
    margin: 20px 0px;
  }

  .downloadDom {
    position: fixed;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
    height: 60px;
    bottom: 0px;
    display: flex;
    color: #fff;
    font-size: 14px;

    .downloadBtn {
      width: 80px;
      height: 30px;
      line-height: 30px;
      background: #fff;
      color: #000;
      text-align: center;
      border-radius: 5px;
      margin-right: 5px;
    }
  }

  .sendLiveComment {
    position: fixed;
    width: 100%;
    bottom: 0px;
    display: flex;
    padding: 0.5rem;
    background: #eee;
    height: 3.5rem;
    z-index: 3;
  }
}
</style>
